const isIE = () =>
  navigator.userAgent.indexOf("MSIE") > -1 ||
  navigator.userAgent.indexOf("Trident/") > -1;
export default isIE;
